import React from "react";

import { Typography, Grid } from "@material-ui/core";

// Expects an array of fieldName, errorValue
const ShowErrors = ({ errors }) => {
  let content;

  if (errors && errors.length && errors.length > 0) {
    content = errors.map((error, index) => {
      return (
        <Grid item>
          <Typography key={index} variant="h6" style={{ color: "red" }}>
            {error.fieldName} - {error.message}
          </Typography>
        </Grid>
      );
    });
  }

  return <>{content}</>;
};

export default ShowErrors;
